import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface StylesDescriptor {
  fullWidth: boolean;
}

@Component({
  name: 'CmgRemoteContent',
})
export default class RemoteContent extends Vue {
  @Prop({ required: false, default: true, type: Boolean })
  fullWidth!: boolean;

  @Prop({ required: false, default: '', type: String })
  content!: string;

  get styles(): object {
    const descriptor = this.getStylesDescriptor();

    return {
      'full-width': descriptor.fullWidth,
    };
  }

  private getStylesDescriptor(): StylesDescriptor {
    return {
      fullWidth: this.fullWidth,
    };
  }
}
